import { Link } from "react-router-dom";
import type { CollectionItem } from "@/mocks/collections";

export default function CollectionCard({ item }: { item: CollectionItem }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/collections/${item.slug}`} className="relative block aspect-[3/4] w-full overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title}合集封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-800">
          {item.category}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-folder-user-line"></i>
            {item.author}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-time-line"></i>
            {item.updated}
          </span>
        </div>
        <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700 md:text-lg">
          <Link to={`/collections/${item.slug}`}>{item.title}</Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-xs leading-5 text-foreground-600 md:text-sm">
          {item.excerpt}
        </p>
        <div className="mt-auto flex items-center justify-between pt-4">
          <span className="chip">
            <i className="ri-price-tag-3-line mr-1"></i>
            {item.tag}
          </span>
          <span className="flex items-center gap-1 text-sm font-medium text-primary-700">
            <i className="ri-file-list-3-line"></i>
            {item.count}
          </span>
        </div>
      </div>
    </article>
  );
}